/**
 * Types pour les utilisateurs
 */

import type { Role, Permission } from './rbac.types';
import type { ProviderGamification } from '@/features/gamification';

// Statuts des utilisateurs
export const UserStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SUSPENDED: 'suspended',
  PENDING: 'pending',
} as const;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];

// Niveau de visibilité des chiffres clés pour chef de projet
export const DataVisibilityLevel = {
  ALL: 'all',
  SIMPLIFIED: 'simplified',
} as const;

export type DataVisibilityLevel = typeof DataVisibilityLevel[keyof typeof DataVisibilityLevel];

// Interface utilisateur
export interface User {
  id: string;
  email: string;
  role: Role;
  status: UserStatus;
  first_name: string;
  last_name: string;
  avatar_url?: string;
  company_id?: string;
  project_ids?: string[]; // DEPRECATED: remplacé par project_manager_activations
  data_visibility_level?: DataVisibilityLevel;
  default_expense_type_id?: string | null;
  default_subcategory_id?: string | null;
  created_at: string;
  updated_at: string;
}

// Interface profil utilisateur (simplifié pour auth)
export interface UserProfile {
  id: string;
  role: Role;
  first_name?: string;
  last_name?: string;
  company_id?: string;
  status?: UserStatus;
  validation_status?: string;
  permissions?: Permission[];
  default_expense_type_id?: string | null;
  default_subcategory_id?: string | null;
  gamification?: ProviderGamification;
}
